import { render } from "./App.vue?vue&type=template&id=cc3bff7c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=cc3bff7c&lang=scss"
script.render = render

export default script